import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { IEventoPrivado } from '@appNeo/core/interfaces/IEventoPrivado';
import { TipoPaginadorEnum } from '@appNeo/neoShared/helpers/enums/TipoPaginador.enum';
import { IRespApi } from '@appNeo/neoShared/helpers/interfaces/IResp-api';
import { Paginator } from '@appNeo/neoShared/models/paginator/paginator';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { CalendarEventNeo, EventColorNeo } from '@appNeo/neoShared/services/calendario/calendario.service';
import { UtilidadesCrudService } from '@appNeo/neoShared/services/utilidades/utilidades-crud.service';
import { format, isPast, isSameDay, isToday } from 'date-fns';
import { catchError, forkJoin, map, Observable, of } from 'rxjs';

const EVENTO_PRIVADO_COLOR = '#DA1884';
const EVENTO_PRIVADO_TEXTO = 'Evento privado';

@Injectable({
  providedIn: 'root'
})
export class EventosPrivadosService extends UtilidadesCrudService {



  constructor(
    http: HttpClient,
    public auxiliar: AuxiliarService,
  ) {
    super(
      http,
      auxiliar,
      'eventosPrivados', /*eventosPrivados*/
      'eventosPrivados', /*eventosPrivados*/
      'Evento privado',
      'Eventos privados',
      [
        'id',
        'identificador',
        'idTipoTurno',
        'descripcion',
        'fechaEvento'
      ]
    );
  }


  getAllCalendario(tipoPaginador?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any) {
    return this.getAll(tipoPaginador, paginator, filtros, true).pipe((
      map(data => this.conversionEventoCalendario(data))),
      catchError((err: IRespApi) => {
        return this.handleError(err, `IRequestAllCalendario${this.nombreEntidadPlural}`);
      })
    );
  }


  conversionEventoCalendario(datos?: IEventoPrivado[], color?: string): CalendarEventNeo[] {
    console.log('Conversion evento calendario ', datos);
    let eventos: CalendarEventNeo[] = [];
    datos.map((eventoPrivado: IEventoPrivado) => {
      let fechaInicio = this.auxiliar.convertirDateEs(eventoPrivado.fechaEvento);
      let fechaFin = fechaInicio;
      let horaInicio = '';
      let horaFin = '';
      fechaInicio = new Date(format(fechaInicio, 'yyyy/MM/dd') + ' ' + horaInicio);
      fechaFin = new Date(format(fechaFin, 'yyyy/MM/dd') + ' ' + horaFin);

      // color heredado de la tarifa
      let colorPrimario = (color) ? eventoPrivado?.color : EVENTO_PRIVADO_COLOR;
      let colorEventoConf = colorPrimario;
      let colorTarifa = colorPrimario;
      let colorEvento: EventColorNeo = { primary: colorPrimario, secondary: colorEventoConf, dia: colorTarifa }
      let evento: CalendarEventNeo<{
        isSameDay: boolean,
        isPast: boolean;
        isToday: boolean,
        isFuture: boolean,
        isWeekend: boolean, entidad: any
      }> = {
        title: eventoPrivado?.tipoTurno.nombre.charAt(0) + '-' + EVENTO_PRIVADO_TEXTO,
        start: fechaInicio,
        end: fechaFin,
        color: colorEvento,
        allDay: false,
        cssClass: '',
        meta: {
          isSameDay: isSameDay(fechaInicio, fechaFin),
          isPast: isPast(fechaFin),
          isToday: isToday(fechaInicio),
          entidad: eventoPrivado
        }
      };
      eventos.push(evento);
    });
    console.log('Conversion evento privado calendario devueltos', datos);
    return eventos;
  }


  /************************************ 
  * Funciones apoyo                  *
  *************************************/
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    let peticion = {};
    const id = route.params?.id;
    if (id) {
      peticion['entidad'] = this.get(id).pipe(
        catchError(err => of(null))
      )
    }
    if (Object.keys(peticion).length > 0) {
      return forkJoin(peticion);
    } else {
      of(true);
    }
  }

}
